export default __webpack_public_path__ + "static/media/michaelangelo.5179d47a.jpg";